export default __webpack_public_path__ + "static/media/051-is greater than.7faaad89.svg";